import styled from "@emotion/styled";

export const LayoutContainer = styled.div`
    background: #eee;
    min-height: 100vh;
    padding-top: 70px;
    display: flex;
    flex-direction: column;
    > div:last-child {
        margin-top: auto;
    }
`;

export const SpinnerContainer = styled.div`
    min-height: calc(100vh - 264px);
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
